/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArtifactsControllerGetFileContentQueryResponse, ArtifactsControllerGetFileContentPathParams, ArtifactsControllerGetFileContent404 } from "../../models/documentArtifactsController/ArtifactsControllerGetFileContent";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { artifactsControllerGetFileContent } from "../../clients/document-artifactsService/artifactsControllerGetFileContent";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const artifactsControllerGetFileContentQueryKey = (documentId: ArtifactsControllerGetFileContentPathParams["documentId"], renditionId: ArtifactsControllerGetFileContentPathParams["renditionId"], artifactId: ArtifactsControllerGetFileContentPathParams["artifactId"]) => [{
  url: '/api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/content',
  params: {
    documentId: documentId,
    renditionId: renditionId,
    artifactId: artifactId
  }
}] as const;
export type ArtifactsControllerGetFileContentQueryKey = ReturnType<typeof artifactsControllerGetFileContentQueryKey>;
export function artifactsControllerGetFileContentQueryOptions(documentId: ArtifactsControllerGetFileContentPathParams["documentId"], renditionId: ArtifactsControllerGetFileContentPathParams["renditionId"], artifactId: ArtifactsControllerGetFileContentPathParams["artifactId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = artifactsControllerGetFileContentQueryKey(documentId, renditionId, artifactId);
  return queryOptions<ArtifactsControllerGetFileContentQueryResponse, ResponseErrorConfig<ArtifactsControllerGetFileContent404>, ArtifactsControllerGetFileContentQueryResponse, typeof queryKey>({
    enabled: !!(documentId && renditionId && artifactId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return artifactsControllerGetFileContent(documentId, renditionId, artifactId, config);
    }
  });
}

/**
 * @description Retrieves the actual file content of an artifact from storage
 * @summary Get artifact file content
 * {@link /api/v1/documents/:documentId/renditions/:renditionId/artifacts/:artifactId/content}
 */
export function useArtifactsControllerGetFileContent<TData = ArtifactsControllerGetFileContentQueryResponse, TQueryData = ArtifactsControllerGetFileContentQueryResponse, TQueryKey extends QueryKey = ArtifactsControllerGetFileContentQueryKey>(documentId: ArtifactsControllerGetFileContentPathParams["documentId"], renditionId: ArtifactsControllerGetFileContentPathParams["renditionId"], artifactId: ArtifactsControllerGetFileContentPathParams["artifactId"], options: {
  query?: Partial<QueryObserverOptions<ArtifactsControllerGetFileContentQueryResponse, ResponseErrorConfig<ArtifactsControllerGetFileContent404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? artifactsControllerGetFileContentQueryKey(documentId, renditionId, artifactId);
  const query = useQuery({
    ...artifactsControllerGetFileContentQueryOptions(documentId, renditionId, artifactId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArtifactsControllerGetFileContent404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}